module.exports = __webpack_public_path__ + "img/s-blog-img.c186857e.jpg";